import { render, staticRenderFns } from "./changsingleinfo.vue?vue&type=template&id=a60b6aee&scoped=true&"
import script from "./changsingleinfo.vue?vue&type=script&lang=js&"
export * from "./changsingleinfo.vue?vue&type=script&lang=js&"
import style0 from "./changsingleinfo.vue?vue&type=style&index=0&id=a60b6aee&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a60b6aee",
  null
  
)

export default component.exports